// Monthly PO budget meter: one threshold for every budget bar (Items step
// toolbar and Review step). Under 90% is normal and shows the brand colour
// (identity, not status); 90-100% is attention (amber); over 100% is a
// problem (red). The ratio is NOT capped, so an overspend stays visible.
export const BUDGET_WARN_RATIO = 0.9
export type BudgetLevel = 'normal' | 'near' | 'over'
export function budgetLevel(ratio: number): BudgetLevel {
  return ratio > 1 ? 'over' : ratio >= BUDGET_WARN_RATIO ? 'near' : 'normal'
}
export const BUDGET_FILL: Record<BudgetLevel, string> = {
  normal: 'bg-[var(--brand)]',
  near: 'bg-[var(--meter-attention)]',
  over: 'bg-[var(--meter-problem)]',
}

// Month's spend if this PO goes through: already-spent plus this PO's total.
// Both budget bars (Items toolbar, Review step) show this figure.
export function projectedSpend(spentDollars: number, poTotal: number): number {
  return spentDollars + poTotal
}
